<template>

  <button @click="showSatisfi">
    <svg
      width="151"
      height="51"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        class="bg"
        d="M.89 0c1.037.479 2.45.702 4.181.974 4.553.718 11.305 1.782 19.195 8.772L65.64 50.75h84.927L99.567 0H.89Z"
        fill="#fff"
      />
      <path
        d="M.89 0c1.037.479 2.45.702 4.181.974 4.553.718 11.305 1.782 19.195 8.772L65.64 50.75h84.927L99.567 0H.89Z"
        fill="url(#a)"
        fill-opacity=".05"
      />
      <path
        class="icon"
        d="m83.35 34.66-.414 1.362c-5.332-.471-8.45-4.11-8.45-7.653v-.963a2.889 2.889 0 0 1 2.888-2.888h8.744a8.23 8.23 0 0 0-3.501 6.74 8.2 8.2 0 0 0 .733 3.403ZM84.115 12a5.296 5.296 0 1 1 0 10.592 5.296 5.296 0 0 1 0-10.592Zm13.48 19.258a6.74 6.74 0 0 1-10.008 5.897l-2.68.814a.612.612 0 0 1-.765-.764l.816-2.679a6.74 6.74 0 1 1 12.637-3.268Zm-8.666-2.889a.963.963 0 0 0 0 1.926h3.852a.963.963 0 1 0 0-1.926h-3.852Zm-.963 4.815a.963.963 0 0 0 .963.963h1.926a.963.963 0 1 0 0-1.926H88.93a.963.963 0 0 0-.963.963Z"
        fill="#0076B6"
      />
      <defs>
        <pattern
          id="a"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlink:href="#image0_616_2776"
            transform="matrix(.00125 0 0 .00369 0 -.975)"
          />
        </pattern>
      </defs>
    </svg>
    <div>
      <span>Chat with a Lions Representative</span>
    </div>
  </button>
</template>
<script setup>
function showSatisfi() {
  SatisfiApp.Global.chatPopupOpen();
}
</script>

<style lang="scss" scoped>
button {
  font-family: "United Sans Cd Hv";
  font-weight: 900;
  border: none;
  font-size: 1em;
  line-height: 0.94;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #0076b6;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  position: relative;
  svg {
    position: relative;
    height: 100%;
    z-index: 1;
    .bg,
    .icon {
      transition: all 0.5s;
    }
  }
  div {
    transition: padding 0.5s;
    margin-left: -50px;
    padding-left: 50px;
    height: 100%;
    padding-right: 70px;
    background: linear-gradient(
        0deg,
        rgba(187, 187, 187, 0.3),
        rgba(187, 187, 187, 0.3)
      ),
      #ffffff;
    display: flex;
    align-items: center;
    position: relative;
    span {
      position: relative;
      z-index: 1;
    }
    &:before {
      content: "";
      transition: opacity 0.5s;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("~@/assets/images/grunge.png");
      pointer-events: none;
      opacity: 0;
    }
  }
  @media (max-width: 749px) {
    display: none;
  }
  @media (hover: hover) {
    &:hover {
      div {
        padding-right: 90px;
        &:before {
          opacity: 0.1;
        }
      }
      .bg {
        fill: #0076b6;
      }
      .icon {
        fill: #fff;
      }
    }
  }
}
</style>